export default "__VITE_ASSET__COMpE2C1__"